/**
 * Business Partner Card Component
 * Displays BP entity information from MCP tool results
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Tag } from 'antd';
import type { BPEntity } from '@/api/types/mcp.types';
import './EntityCard.css';

interface BPCardProps {
  bp: BPEntity;
  compact?: boolean;
}

export const BPCard: React.FC<BPCardProps> = ({ bp, compact = false }) => {
  const typeColors: Record<string, string> = {
    company: 'blue',
    individual: 'green',
    partner: 'purple',
  };

  return (
    <div className={`bp-card entity-card ${compact ? 'compact' : ''}`}>
      <div className="entity-card-header">
        <h4 className="entity-card-title">{bp.name}</h4>
        {bp.bp_type && (
          <Tag color={typeColors[bp.bp_type] || 'default'}>{bp.bp_type}</Tag>
        )}
      </div>

      {!compact && (
        <div className="entity-card-body">
          <div className="entity-card-field">
            <span className="field-label">ID:</span>
            <span className="field-value">{bp.id.substring(0, 8)}...</span>
          </div>
        </div>
      )}

      <div className="entity-card-footer">
        <Link to={`/apps/bp/${bp.id}`} className="entity-card-link">
          View Details →
        </Link>
      </div>
    </div>
  );
};
